import { COMPANY, CERTIFICATIONS } from "@/lib/site-data";

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="bg-white py-24 md:py-32 border-t border-slate-200"
    >
      <div className="container-narrow grid grid-cols-1 md:grid-cols-12 gap-8">
        <div className="md:col-span-5">
          <div className="overline text-emerald-800 mb-5">— About</div>
          <h2 className="font-serif text-3xl md:text-5xl tracking-tight leading-tight text-slate-950">
            A Polish house, working at European scale.
          </h2>
          <div className="mt-10 overflow-hidden border border-slate-200">
            <img
              src="https://images.pexels.com/photos/7212946/pexels-photo-7212946.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
              alt="Team of consultants in collaborative session"
              className="w-full h-72 md:h-96 object-cover"
              loading="lazy"
            />
          </div>
        </div>

        <div className="md:col-span-6 md:col-start-7">
          <p className="font-serif text-2xl md:text-3xl text-slate-950 leading-snug tracking-tight">
            “We exist for the work that matters to a board: cross-border
            programmes, regulated platforms and infrastructure that has to
            survive a decade of audits.”
          </p>
          <p className="mt-8 text-slate-700 leading-relaxed">
            {COMPANY.legalName} (trading as <strong>{COMPANY.tradeName}</strong>) was
            founded in {COMPANY.founded} in {COMPANY.hqCity}. We were created to
            close a specific gap: large consultancies sell strategy decks,
            engineering shops sell capacity — but boards needed someone to own
            the seam between the two. That seam is where we live.
          </p>
          <p className="mt-5 text-slate-700 leading-relaxed">
            Today we lead programmes in {17} countries across information
            technology, water & climate infrastructure, and regulated financial
            services. Our partners hold PMP, PRINCE2 and ISO 27001 lead auditor
            credentials — and every engagement is accountable to a written,
            measurable outcome.
          </p>

          <div className="mt-10 grid grid-cols-2 gap-x-8 gap-y-6 border-t border-slate-200 pt-8">
            <div>
              <div className="overline text-slate-500 mb-2">Registered office</div>
              <div className="text-slate-950 text-sm">{COMPANY.hqAddress}</div>
            </div>
            <div>
              <div className="overline text-slate-500 mb-2">REGON / NIP</div>
              <div className="text-slate-950 text-sm font-mono">
                {COMPANY.regon}
              </div>
            </div>
            <div>
              <div className="overline text-slate-500 mb-2">Founded</div>
              <div className="text-slate-950 text-sm">{COMPANY.founded}</div>
            </div>
            <div>
              <div className="overline text-slate-500 mb-2">Coverage</div>
              <div className="text-slate-950 text-sm">Europe & Worldwide</div>
            </div>
          </div>

          <div className="mt-10">
            <div className="overline text-slate-500 mb-4">Credentials & frameworks</div>
            <div className="flex flex-wrap gap-2">
              {CERTIFICATIONS.map((c) => (
                <span
                  key={c}
                  data-testid={`cert-${c.replace(/\s+/g, "-").toLowerCase()}`}
                  className="border border-slate-300 text-slate-700 px-3 py-1.5 text-xs"
                >
                  {c}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
